import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import { baseurl } from "../../constant";
import Loading from "../../loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const UpipayoutReport = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState(0);
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [err, seterr] = useState();
  const [loading, setloading] = useState();
  const [datalength, setdatalength] = useState();

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const viewall = async () => {
    setstartdate(new Date().toLocaleDateString("en-CA"));
    setenddate(new Date().toLocaleDateString("en-CA"));
    setkeyword("");
    setstatus("");
    getdata1();
  };

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);
  // const SerialNumber = (currentPage - 1) * pageRecord + index;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Pagination(totalPage, currentPage);

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(1, currentPage - 1, currentPage, currentPage + 1, totalPage);
    }
  }

  const getdata1 = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "upiPayoutReportAuth", {
        token: token,
        pageno: 1,
        pageRecord: pageRecord,
        fromDate: new Date().toLocaleDateString("en-CA"),
        toDate: new Date().toLocaleDateString("en-CA"),
        keyword: "",
        status: "",
      });

      await setdata(result.data);
      await settotalrecord(result.data.totalRecord);
      setdatalength(result.data.data.length);
      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };

  const getdata = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "upiPayoutReportAuth", {
        token: token,
        pageno: currentPage,
        pageRecord: pageRecord,
        fromDate: startdate,
        toDate: enddate,
        keyword: keyword,
        status: status,
      });

      await setdata(result.data);
      await settotalrecord(result.data.totalRecord);
      setdatalength(result.data.data.length);
      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };

  useEffect(() => {
    getdata();
  }, [currentPage]);
  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <div className="row">
              <div className="col-sm-12">
                <h4>
                  <b> UPI Payout Report</b>
                </h4>
              </div>

              <div className="col-sm-2">
                <select
                  className="form-control"
                  value={status}
                  onChange={(e) => {
                    setstatus(e.target.value);
                  }}
                >
                  <option value="0">All Status</option>
                  <option value="2">Pending</option>
                  <option value="3">Success</option>
                  <option value="4">Failed</option>
                </select>
              </div>

              <div className="col-sm-2">
                <DatePicker
                  className="form-control datepick"
                  selected={startdate}
                  onChange={(date) => setstartdate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={startdate}
                />
              </div>
              <div className="col-sm-2">
                {" "}
                <DatePicker
                  className="form-control datepick"
                  selected={enddate}
                  onChange={(date) => setenddate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={enddate}
                />
              </div>
              <div className="col-sm-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keyword"
                  name="keyword"
                  value={keyword}
                  onChange={(e) => {
                    setkeyword(e.target.value);
                  }}
                />
              </div>

              <div className="col-sm-4">
                <button
                  type="button"
                  className="btn btn-success"
                  id="upiPayoutSearchBtn"
                  onClick={() => getdata()}
                >
                  Search
                </button>
                <a
                  className="btn btn-secondary"
                  onClick={() => {
                    viewall();
                  }}
                  style={{ margin: "5px" }}
                >
                  View All
                </a>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                id="upiPayoutDataTable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>MemberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
                <tbody>
                  {datalength > 0 ? (
                    data.data.map((item, index) => (
                      <tr>
                        <td>{(currentPage - 1) * pageRecord + index + 1}</td>
                        <td>{item.user_code}</td>
                        <td>{item.account_holder_name}</td>
                        <td>{item.account_no}</td>
                        <td>{item.transfer_amount}</td>
                        <td>{item.txnType}</td>
                        <td>{item.transaction_id}</td>
                        <td>{item.rrn}</td>
                        {(item.status == 4 || item.status == 0) && (
                          <td style={{ color: "red" }}>Failed</td>
                        )}
                        {item.status == 2 && (
                          <td style={{ color: "orange" }}>Pending</td>
                        )}
                        {item.status == 3 && (
                          <td style={{ color: "green" }}>Success</td>
                        )}
                        <td>{FormatDate(item.created)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th colspan="11" style={{ textAlign: "center" }}>
                        There is no data in table
                      </th>
                    </tr>
                  )}
                </tbody>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>MemberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
              </table>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage == 1}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                previous
              </button>
              {pages.map((page, index) => (
                <button
                  key={index}
                  onClick={() => page !== "..." && handlePageChange(page)}
                  style={{
                    padding: "10px 15px",
                    margin: "5px",
                    backgroundColor: currentPage === page ? "red" : "#f0f0f0",
                    color: currentPage === page ? "#fff" : "#000",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    cursor: page === "..." ? "default" : "pointer",
                    fontWeight: page === "..." ? "bold" : "normal",
                  }}
                  disabled={page === "..."}
                >
                  {page}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPage || datalength === 0}
                style={{
                  padding: "10px 15px",
                  margin: "5px",

                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpipayoutReport;
